import React from 'react';
import PropTypes from 'prop-types';
import {css} from '@emotion/react';
import {styled} from '@mui/material/styles';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import Stack from '@mui/material/Stack';
import ChevronDownOutlinedIcon from '@tenancy.nz/icons/ChevronDownOutlined';
import ChevronUpOutlinedIcon from '@tenancy.nz/icons/ChevronUpOutlined';
import {Text} from '@tenancy.nz/ui';
import {getObjectProp} from '../utils/helpers/object';
import {isFunction} from '../utils/helpers/boolean';

const StyledActiveIndicator = styled('span')`
  ${({open, visible, theme}) => css`
    display: flex;
    height: 100%;
    width: ${!open ? '0px' : '8px'};
    background-color: ${getObjectProp(theme, 'vars.palette.tertiary.main')};
    transition: width 0.3s ease;
    opacity: ${visible ? '1' : '0'};
    visibility: ${visible ? 'visible' : 'hidden'};
  `}
`;

//  ${open &&
// css`
//   padding-left: ${24 * (depth + 1)}px;
// `}

// ${!open &&
// css`
//   // padding-left: 24px;
// `}

const StyledItemButton = styled(ListItemButton)`
  ${({depth, open, selected, theme}) => css`
    && {
      padding: 0 0 0 0;
      position: relative;
      height: 64px;

      ${theme.breakpoints.up('md')} {
        height: 54px;
      }

      &:before {
        content: '';
      }

      &:hover {
        background-color: #cef3ed;
      }

      ${!open &&
      selected &&
      css`
        background-color: #cef3ed;
      `}

      ${open &&
      selected &&
      css`
        background-color: #cef3ed;

        &:before {
          opacity: 1;
          visibility: visible;
        }
      `}
    }
  `}
`;

function NavListItem({
  depth = 0,
  expanded = false,
  icon = null,
  label,
  onClick,
  selected = false,
  open = true,
  subItemContent = undefined,
  ...rest
}) {
  const handleClick = e => {
    e.stopPropagation();
    if (isFunction(onClick)) {
      onClick(e);
    }
  };
  return (
    <ListItem disablePadding {...rest}>
      <Stack flex={1}>
        <StyledItemButton
          depth={depth}
          onClick={handleClick}
          selected={selected}
          open={open}>
          <StyledActiveIndicator
            component="span"
            visible={selected}
            open={open}
          />
          {icon && (
            <Stack
              component="span"
              alignItems="center"
              justifyContent="center"
              sx={{
                width: open ? '52px' : '68px',
                color: 'primary.main',
                fontSize: '24px',
                height: '44px',
              }}>
              {icon}
            </Stack>
          )}
          <Stack>
            <Text
              as="span"
              variant="body2"
              weight={selected ? '700' : '500'}
              nowrap
              color="primary">
              {label}
            </Text>
          </Stack>
          {open && subItemContent && (
            <Stack component="span" sx={{ml: 'auto', color: 'primary.main'}}>
              {expanded ? (
                <ChevronUpOutlinedIcon />
              ) : (
                <ChevronDownOutlinedIcon />
              )}
            </Stack>
          )}
        </StyledItemButton>
        {subItemContent}
      </Stack>
    </ListItem>
  );
}

NavListItem.propTypes = {
  depth: PropTypes.number,
  expanded: PropTypes.bool,
  icon: PropTypes.node,
  label: PropTypes.node.isRequired,
  open: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  subItemContent: PropTypes.node,
};

NavListItem.defaultProps = {
  depth: 0,
  icon: null,
  expanded: false,
  open: true,
  selected: false,
  subItemContent: undefined,
};

export default NavListItem;
